import React from 'react';
import { MegarubigramStore } from './MegarubigramStore';
import OuterControlGrid from './components/OuterControlGrid';
import PuzzleTopBar from '../shared/PuzzleTopBar';
import { onReveal, saveMegarubigram } from './megarubigramUtils';
import Instructions from './components/Instructions';
import { PuzzleNames } from '../../../utils/types';
import { useAmplitudeTracking, useFirstTimeInstructions, useIsMobileDimensions, usePageVisibilityPause, useStructuredDataEmbedding } from '../shared/utils';
import PauseCover from '../shared/PauseCover';
import { isMobile } from 'react-device-detect';
import { usePuzzleTracking } from '../../../utils/usePuzzleTracking';
import './Megarubigram.less';

const Megarubigram = () => {
  const { solved, revealed } = MegarubigramStore.useState();
  const useMobileStyles = isMobile || useIsMobileDimensions();

  useFirstTimeInstructions(PuzzleNames.Rubigram, MegarubigramStore as any);
  usePageVisibilityPause(MegarubigramStore as any, saveMegarubigram);
  useStructuredDataEmbedding(PuzzleNames.Megarubigram);
  useAmplitudeTracking(PuzzleNames.Megarubigram);
  usePuzzleTracking(PuzzleNames.Megarubigram);

  const puzzleContainerClasses =
    `puzzleContainer megarubigramContainer`
    + ` ${solved ? 'solved' : ''}`
    + ` ${useMobileStyles ? 'mobile': ''}`;

  return (
    <>
      <PuzzleTopBar
        puzzleName={PuzzleNames.Megarubigram}
        store={MegarubigramStore as any}
        onReveal={onReveal}
        onSave={saveMegarubigram}
        InstructionsComponent={Instructions}
      />
      <div className={puzzleContainerClasses}>
        <OuterControlGrid/>
        {revealed &&
          <div className="outcomeBanner">
            <div>Solution revealed. Try again next time!</div>
            <div>New Megarubigrams on Tuesdays and Fridays.</div>
          </div>
        }
        {solved &&
          <div className="outcomeBanner">
            Solved! New Megarubigrams on Tuesdays and Fridays.
          </div>
        }
        <PauseCover store={MegarubigramStore as any}/>
      </div>
    </>
  );
};

export default Megarubigram;